import { PortfolioHoldings } from '../components/PortfolioHoldings';

export default function DashboardPage({ role }) {
  return (
    <div className="space-y-6">
      {/* <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold">Portfolio Dashboard</h1>
          <p className="text-muted-foreground mt-1">
            Monitor your investments and track performance
          </p>
        </div>
      </div> */}
      <PortfolioHoldings role={role} />
    </div>
  );
}
